export var DevicePermission;
(function (DevicePermission) {
    DevicePermission["GeoLocation"] = "geolocation";
    DevicePermission["Media"] = "media";
    DevicePermission["Midi"] = "midi";
    DevicePermission["Notifications"] = "notifications";
    DevicePermission["OpenExternal"] = "openExternal";
})(DevicePermission || (DevicePermission = {}));
export var PermissionStatus;
(function (PermissionStatus) {
    PermissionStatus["Consented"] = "consented";
    PermissionStatus["Revoked"] = "revoked";
    PermissionStatus["NeverAsked"] = "neverAsked";
})(PermissionStatus || (PermissionStatus = {}));
//# sourceMappingURL=permission.js.map